import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'

interface VulnerableModalProps {
  onCancel: () => void
  onConfirm: () => void
  telecom: number
}

const DEFAULT_TITLE = '서비스 안내'
const DEFAULT_CANCEL_TEXT = '취소'

const SKT_TITLE =
  '휴대폰가족보호는 만 75세 이상 고객님의 안전한 서비스 이용을 위해 아래 사항을 충분히 안내합니다.'
const SKT_CHILDREN = (
  <>
    본 서비스는 월 3,300원(VAT포함)의 유료서비스이며, 복잡한 디지털 조작이 필요할 수 있습니다.
    <br />
    언제든지 해지 가능합니다.
  </>
)

const SKT_CONFIRM = <>계속 진행하기</>

const SKT_CANCEL = <>중단하기</>

const KT_CHILDREN = (
  <>
    휴대폰을 통해 가족 구성원의 상태를 확인하고 도움이 필요한 상황을 알려 안전하게 보호받을 수 있는{' '}
    <span style={{ color: '#FF4E4E' }}>월 3,300원(VAT포함) 유료부가서비스</span>
    입니다.
    <br />
    가입을 진행하시겠습니까?
  </>
)

const KT_CONFIRM = (
  <>
    휴대폰가족보호
    <br />
    유료가입(월 3,300원)
  </>
)

const LGUP_CHILDREN = (
  <>
    휴대폰을 통해 가족 구성원의 상태를 확인하고 도움이 필요한 상황을 알려 안전하게 보호받을 수 있는
    유료부가서비스입니다.
    <br />
    가입을 진행하시겠습니까?
  </>
)

const LGUP_CONFIRM = <>확인</>

const VulnerableModal = ({ onCancel, onConfirm, telecom }: VulnerableModalProps): JSX.Element => {
  const modalTitle = telecom === 0 ? SKT_TITLE : DEFAULT_TITLE
  const modalCancelText = telecom === 0 ? SKT_CANCEL : DEFAULT_CANCEL_TEXT
  let modalChildren: React.ReactNode
  let modalConfirmText: React.ReactNode

  switch (telecom) {
    case 0:
      modalChildren = SKT_CHILDREN
      modalConfirmText = SKT_CONFIRM
      break
    case 1:
      modalChildren = KT_CHILDREN
      modalConfirmText = KT_CONFIRM
      break
    case 2:
      modalChildren = LGUP_CHILDREN
      modalConfirmText = LGUP_CONFIRM
      break
    default:
      modalChildren = SKT_CHILDREN
      modalConfirmText = SKT_CONFIRM
      break
  }

  return (
    <ModalVulnerableContent>
      <ModalVulnerableInner>
        <h3 className={telecom === 0 ? 'isMultiLine' : ''}>{modalTitle}</h3>
        <p>{modalChildren}</p>
      </ModalVulnerableInner>
      <ModalVulnerableFooter>
        <ModalBtn bgColor={COLOR.blueGray3} onClick={onCancel}>
          <span>{modalCancelText}</span>
        </ModalBtn>
        <ModalBtn
          bgColor={COLOR.point1}
          onClick={onConfirm}
          className={telecom === 1 ? 'isSmallText' : ''}
        >
          <span>{modalConfirmText}</span>
        </ModalBtn>
      </ModalVulnerableFooter>
    </ModalVulnerableContent>
  )
}

export default VulnerableModal

const ModalVulnerableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
`
const ModalVulnerableInner = styled.div`
  > h3 {
    margin: 0 0 16px 0;
    font-family:
      Noto Sans KR,
      sans-serif;
    font-size: 18px;

    &.isMultiLine {
      font-size: 16px;
      white-space: normal;
    }
  }
  > p {
    margin: 0;
    padding: 16px;
    background-color: ${COLOR.gray10};
    border-radius: 10px;
    font-family:
      Noto Sans KR,
      sans-serif;
    font-size: 14px;
    white-space: normal;

    > span {
      color: ${COLOR.red2};
    }
  }
`
const ModalVulnerableFooter = styled.div`
  display: flex;
  gap: 12px;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    flex: 1;
    > span {
      font-family:
        Noto Sans KR,
        sans-serif;
      font-weight: 700;
    }
  }

  > .isSmallText {
    line-height: 14px;
    > span {
      font-size: 12px;
    }
  }
`
